<template>
  <Loader v-if="loadingFilter" />
  <div class="flex justify-content-center flex-wrap">
    <Button :class="`m-2 btn-filter flex justify-content-center ${type.selected ? 'selected' : ''}`" v-for="type in types_pp" :key="type.name" @click="getListVoltura(type)" :disabled="loadingFilter">
      Visualizza {{ type.name.toUpperCase() }}
    </Button>
  </div>
  <div class="table-container" style="overflow-x: auto" v-if="currentData">
    <div v-if="showSuccessAlert" class="p-col-12 p-d-flex p-jc-center" style=" margin-top: 20px; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 9999;">
      <div class="p-alert p-component p-alert-success" x role="alert" style=" box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15); border-radius: 4px; background-color: #52c41a; color: #fff; padding: 10px 20px;">
        <div class="p-alert-content">Preventivo aggiunto con successo!</div>
      </div>
    </div>
    <div v-if="showSuccessAlert2" class="p-col-12 p-d-flex p-jc-center" style="margin-top: 20px; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 9999;">
      <div class="p-alert p-component p-alert-success-allegato" role="alert" style=" box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15); border-radius: 4px; background-color: #52c41a;   color: #fff;   padding: 10px 20px;">
        <div class="p-alert-content">Allegato caricato con successo!</div>
      </div>
    </div>
    <DataTable v-model:filters="filters" :value="filteredVoltura" responsiveLayout="scroll" dataKey="id" editMode="cell" filterDisplay="row" :globalFilterFields="['code', 'stato_corrispondente']" :paginator="true" :rows="50" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" :rowsPerPageOptions="[10, 20, 50, 100, 500]" currentPageReportTemplate="{first} a {last} di {totalRecords}"  :rowClass="rowClass">
      <template #header>
        <div class="flex flex-wrap align-items-center justify-content-between gap-2">
          <div class="flex">
            <div class="flex align-items-center">
              <Checkbox v-model="has_selectedRows" :binary="true" @update:modelValue="selectAllRows" class="m-3" :disabled="is_disabled_selected_all"/>
              <label>{{ has_selectedRows ? "Deseleziona tutti" : "Seleziona tutti"
              }}</label>
            </div>
            <InputText v-model="searchTerm" placeholder="Cerca..." class="p-inputtext p-component ml-4 mt-4 mb-4" style="width: 300px"/>
          </div>
          <div>
            <Button v-if="filteredVoltura.length > 0" label="Esporta File" icon="pi pi-file-excel" class="m-2 p-button-rounded p-button-raised" @click="exportToExcel"/>
            <Button v-if="isVisibleBtnDownloadVolture" class="m-2 p-button-rounded p-button-raised" icon="pi pi-download" label="Scarica volture" @click="downloadFileVoltura"/>
          </div>
        </div>
        <hr style="margin: 20px 0; border-top: 0.5px solid #ccc;" />
        <div>
          <label>Seleziona altri stati pratica da cercare</label>
          <div class="flex flex-wrap align-items-center">
            <MultiSelect v-model="searchedStatus.new" :options="types_stato_pratica" optionLabel="stato" placeholder="Seleziona altri stati pratica da cercare" class="mt-2"/>
            <Button v-if="isVisibleBtnSearchedStatus" icon="pi pi-search" @click="setSearchedStatus" class="ml-2"/>
          </div>
        </div>
        <hr/>
        <div style="display: flex; align-items: center">
          <div v-if="user && ['admin','pratiche'].includes(user.profile.name)">
            <Dropdown v-model="massiveSelectedStatus" :options="statiMassivi" optionLabel="stato" placeholder="Seleziona Stato" class="mb-4"/>
          </div>
          <Button label="Applica Stato" class="ml-1 mb-4" @click="applyMassiveStatusChange" :disabled="!(user && ['admin','pratiche'].includes(user.profile.name))"/>
        </div>
      </template>
      <template #empty>
        Non ci sono pratiche di voltura 
      </template>
      <!-- <Column selectionMode="multiple" headerStyle="width: 3em"></Column> -->
      <Column headerStyle="width: 3rem">
        <template #body="{ data }">
          <Checkbox v-if="data.canSelect" v-model="data.selected" :binary="true" @update:modelValue="inSelectedRows(data)"/>
        </template>
      </Column>
      <Column header="Stato Pratica">
        <template #body="{ data }">
          <Button icon="pi pi-info-circle" @click="openInfoDialog(data.cod_type_stato_pratica, data, index)"></Button>
        </template>
      </Column>
      <Column field="id" header="Id Pratica" sortable></Column>
      <Column field="matrice_id" header="Id matrice" sortable></Column>
      <Column field="code" header="Fornitura">
        <template #filter="{ filterModel, filterCallback }">
          <InputText v-model="filterModel.value" type="text" @input="filterCallback()" style="min-width: 10rem" placeholder="Ricerca fornitura"/>
        </template>
      </Column>
      <Column field="data_inizio" header="Data Inizio Fornitura" sortable>
        <template #body="{data}">
          {{ moment(data.data_inizio).format('DD/MM/Y') }}
        </template>
      </Column>
      <Column field="data_fine" header="Data Fine Fornitura" sortable>
        <template #body="{data}">
          {{ moment(data.data_fine).format('DD/MM/Y') }}
        </template>
      </Column>
      <Column field="dataValidazione" header="Data Validazione" sortable>
        <template #body="{data}">
          {{ moment(data.dataValidazione).format('DD/MM/Y HH:mm:ss') }}
        </template>
      </Column>
      <Column field="denominazione" header="Ragione Sociale" style="width: 150px">
        <template #body="{ data }">
          <p @click="handleButtonClick3(data.clientid)" class="text-primary cursor-pointer">
            {{ data.denominazione }}
          </p>
        </template>
      </Column>
      <Column field="cf" header="Codice Fiscale"></Column>
      <Column field="piva" header="Partita Iva"></Column>
      <Column field="referente" header="Referente"></Column>
      <Column field="matricola" header="Matricola"></Column>
      <Column field="protocollo" header="PROTOCOLLO SII" editMode="cell">
        <template #editor="{ data, field }">
          <input type="text" v-model="data[field]" @blur="saveEdit(data.id, field, data[field])" @keydown.enter.prevent="saveEdit(data.id, field, data[field])" class="p-inputtext p-component"/>
        </template>
      </Column>
      <Column field="udd" header="UDD" editMode="cell">
        <template #editor="{ data, field }">
          <input type="text" v-model="data[field]" @blur="saveEdit(data.id, field, data[field])" @keydown.enter.prevent="saveEdit(data.id, field, data[field])" class="p-inputtext p-component"/>
        </template>
      </Column>
      <Column field="tipoFornitura" header="Tipologia Uso"></Column>
      <Column field="cell" header="Telefono"></Column>
      <!-- <Column field="indirizzo_completo" header="Indirizzo"></Column> -->
      <Column field="toponimo" header="Toponimo"></Column>
      <Column field="indirizzo" header="Indirizzo"></Column>
      <Column field="civico" header="Civico"></Column>
      <Column field="cap" header="Cap"></Column>
      <Column field="comune" header="Comune"></Column>
      <Column field="code_provincia" header="Provincia"></Column>
      <Column field="istat" header="Istat"></Column>
      <Column field="email" header="Email"></Column>
      <Column field="stato_corrispondente" header="Stato" sortable :showFilterMenu="false" :style="{ width: '14rem' }">
        <template #body="{ data }">
          <div class="flex flex-column align-items-center">
            {{ data.stato_corrispondente }}
            <div v-if="data.cod_type_stato_pratica == 10">
              {{ data.nota }} - {{ data.cod_errore_sii }} - {{ data.motivazione_errore_sii }}
            </div>
          </div>
        </template>
        <template #filter="{ filterModel, filterCallback }">
          <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="types_stato_pratica"
            placeholder="Seleziona stato" style="min-width: 10rem" optionLabel="stato" optionValue="stato">
            <template #option="slotProps">
              {{ slotProps.option.stato }}
            </template>
          </Dropdown>
        </template>
      </Column>
      <Column header="File">
        <template #body="{ data }">
          <Button icon="pi pi-folder" @click="openFilesDialog(data.id, data.matrice_id)" />
        </template>
      </Column>
    </DataTable>
    <Dialog v-model:visible="filesDialogVisible" modal header="File Associati Alla Pratica" :style="{ width: '50rem' }"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
      <div class="files-list">
        <ul>
          <li v-for="file in selectedFiles" :key="file.matrice_documenti_id" class="file-link"
            @click="downloadPdf(selectedMatriceId, file.filename)">
            {{ file.filename }}
          </li>
        </ul>
        <Button label="Scarica tutti i file" @click="downloadZip(selectedMatriceId)" icon="pi pi-download" />
      </div>
    </Dialog>
    <Dialog v-model:visible="dialoginfo" modal header="Stato Pratiche" :style="{ width: '80rem' }"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" class="custom-dialog stato-dialog">
      <div class="dialog-content stato-layout">
        <div class="timeline-container">
          <Timeline v-if="timelineData && timelineData.length > 0" :value="timelineData" :key="timelineKey">
            <template #marker="slotProps">
              <span
                class="stato-punto"
                :class="{ 'stato-punto--attivo': Number(slotProps.item.numero) === Number(selectedpratica && selectedpratica.cod_type_stato_pratica) }"
              ></span>
            </template>
            <template #content="slotProps">
              <div class="stato-passo">
                <span
                  class="stato-passo__nome"
                  :class="{ 'stato-passo__nome--attivo': Number(slotProps.item.numero) === Number(selectedpratica && selectedpratica.cod_type_stato_pratica) }"
                >{{ slotProps.item.stato }}</span>
                <SottostatiTimeline
                  :voci="slotProps.item.sottostati"
                  :corrente="selectedpratica && selectedpratica.cod_type_stato_pratica"
                />
              </div>
            </template>
          </Timeline>
        </div>
                <div class="data-tables-container stato-pannello">
          <div class="stato-scheda" v-if="selectedpratica">
            <div class="stato-scheda__voce">
              <span>Pratica</span>
              <strong>Voltura</strong>
            </div>
            <div class="stato-scheda__voce">
              <span>Cliente</span>
              <strong>{{
                selectedpratica.denominazione
                || [selectedpratica.nomerappresentante, selectedpratica.cognomerappresentante].filter(Boolean).join(" ")
                || [selectedpratica.NomeCliente, selectedpratica.CognomeCliente].filter(Boolean).join(" ")
                || selectedpratica.intestatario
                || "-"
              }}</strong>
            </div>
            <div class="stato-scheda__voce">
              <span>POD/PDR</span>
              <strong>{{ selectedpratica.code || "-" }}</strong>
            </div>
            <div class="stato-scheda__voce">
              <span>Stato attuale</span>
              <strong>{{ selectedpratica.stato_corrispondente || selectedpratica.stato_pratica || "-" }}</strong>
            </div>
          </div>
          <section class="stato-blocco stato-modulo" v-if="selectedpratica">
            <h3>Aggiorna stato</h3>
            <label class="stato-campo">
              <span>Stato</span>
              <Dropdown
                v-model="selectedpratica.selectedStato"
                :options="vedeSoloPreventivo(user) ? statiSoloPreventivo : newStati"
                optionLabel="stato"
                @change="changePraticaStatus(selectedpratica)"
              />
            </label>
            <label class="stato-privato">
              <input
                type="checkbox"
                v-model="selectedpratica.privato"
                @change="changePraticaStatus(selectedpratica)"
                :true-value="1"
                :false-value="0"
                :disabled="isPrivateAutomaticallyManaged"
              />
              Privato
            </label>
            <NotaInvioDocumentazione v-model="selectedpratica.nota" :pratica="selectedpratica">
              <template #default="{ openEditor, isDocumentationState }">
                <Button
                  v-if="isDocumentationState"
                  type="button"
                  label="Inserisci documentazione"
                  icon="pi pi-file-edit"
                  @click="openEditor"
                />
                <label v-else class="stato-campo">
                  <span>Nota</span>
                  <textarea
                    class="stato-nota"
                    :value="selectedpratica.nota || ''"
                    placeholder="Inserisci la nota"
                    @input="selectedpratica.nota = $event.target.value"
                  />
                </label>
              </template>
            </NotaInvioDocumentazione>
            <button
              type="button"
              class="styled-button-Nota"
              :class="{
                'styled-button-Nota--invio': faseInvioStato === 'invio',
                'styled-button-Nota--ok': faseInvioStato === 'inviato',
              }"
              :disabled="faseInvioStato === 'invio'"
              @click="inviaStatoAnimato(selectedpratica)"
            >
              <span v-if="faseInvioStato === 'invio'" class="invio-stato__spinner" aria-hidden="true"></span>
              <span v-else-if="faseInvioStato === 'inviato'" class="invio-stato__check" aria-hidden="true">✓</span>
              {{ faseInvioStato === 'invio' ? 'Invio…' : faseInvioStato === 'inviato' ? 'Inviato' : 'Invia' }}
            </button>
          </section>
          <form @submit.prevent="onSubmitFileUpload" class="form-container stato-blocco stato-file">
            <h3>File</h3>
            <div class="stato-file__riga">
              <span class="stato-file__nome">Allegato</span>
              <div class="button-group">
              <label for="fileInput1" class="custom-file-upload" id="fileLabel1">
                Carica Allegato
              </label>
              <input type="file" id="fileInput1" @change="handleUploadPratiche($event)" class="file-input2" />
              <button v-if="selectedpratica !== null" @click="
                downloadAllegatoPratica(
                  selectedpratica.code,
                  selectedpratica.id
                )
                " class="custom-file-download">
                Scarica Allegato
              </button>
            </div>
            </div>
            <div class="stato-file__riga">
              <span class="stato-file__nome">Preventivo</span>
              <div class="button-group">
              <label 
                v-if="user && ['admin','pratiche'].includes(user.profile.name)"
                for="fileInput2" 
                class="custom-file-upload" 
                id="fileLabel2"
              >
                <i class="fas fa-cloud-upload-alt"></i> Carica Preventivo
              </label>
              <input 
                v-if="user && ['admin','pratiche'].includes(user.profile.name)"
                type="file" 
                id="fileInput2" 
                @change="handleFileChange($event)" 
                class="file-input" 
              />
              <button 
                v-if="selectedpratica !== null" 
                @click="downloadPreventivoPratica(selectedpratica.id)" 
                class="custom-file-download"
              >
                <i class="pi pi-download"></i> Scarica Preventivo
              </button>
            </div>
            </div>
            <PreventivoFirmatoBox
              :stato="selectedpratica && selectedpratica.selectedStato"
              :pratica-id="selectedpratica && selectedpratica.id"
              type-file="Voltura"
              @file="impostaFilePreventivoFirmato"
            />
            <div class="p-alert-content" id="error-alert" style="display: none">
              Non ci sono file da scaricare.
            </div>
          </form>
          <section class="stato-blocco stato-storico">
            <h3>Storico note</h3>
            <DataTable :value="selectedpratica.states" :paginator="true" :rows="3">
              <Column field="data_nota" header="Data"></Column>
              <Column field="stato_corrispondente" header="Stato"></Column>
              <Column field="nota" header="Nota"></Column>
              <Column field="is_private" header="Privato">
              <template #body="{ data }">
                <span v-if="data.is_private === 0" class="text-color-secondary">No</span>
                <span v-else-if="data.is_private === 1">SI</span>
              </template>
            </Column>
            </DataTable>
          </section>
          <section class="stato-blocco stato-importo">
            <h3>Importo</h3>
            <div v-if="preventivoEsistente" class="preventivo-esistente">
              <p><strong>Preventivo già inserito:</strong> € {{ preventivoEsistente.importo.toFixed(2) }}</p>
            </div>
            <button 
              v-else
              @click="openPreventivo" 
              class="styled-button-Nota-Preventivo"
            >
              Genera Preventivo
            </button>
          </section>
        </div>
      </div>
    </Dialog>
    <Dialog v-model:visible="preventivoDialog" modal header="Genera Preventivo" :style="{ width: '50rem' }">
      <div class="p-fluid">
        <div class="p-field p-grid mb-3">
          <label class="p-col-12"><b>Importo (€):</b></label>
          <div class="p-col-12 mt-2">
            <InputNumber v-model="importoPreventivo" mode="currency" currency="EUR" locale="it-IT" />
          </div>
        </div>

        <div class="p-field p-grid mb-2">
          <label class="p-col-12"><b>Dati Cliente:</b></label>
          <div class="p-col-12">
            <div class="cliente-info">
              <p><b>Ragione Sociale:</b> {{ selectedpratica?.denominazione || '-' }}</p>
              <p><b>Codice Fiscale:</b> {{ selectedpratica?.cf || '-' }}</p>
              <p><b>Partita IVA:</b> {{ selectedpratica?.piva || '-' }}</p>
              <p><b>Telefono:</b> {{ selectedpratica?.cell || '-' }}</p>
              <p><b>Email:</b> {{ selectedpratica?.email || '-' }}</p>
              <p><b>Indirizzo:</b> {{ selectedpratica?.indirizzo_completo || '-' }}</p>
              <p><b>Codice POD/PDR:</b> {{ selectedpratica?.code || '-' }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="dialog-footer" style="text-align: right; margin-top: 20px;">
        <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="preventivoDialog = false" />
        <Button label="Genera" icon="pi pi-check" class="p-button-success" @click="generaPreventivo" />
      </div>
    </Dialog>
    <Dialog v-model:visible="isDownloadedFilePratica" modal :style="{ width: '80rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" class="custom-dialog">
      <div class="col-12">
        <p class="mb-4 flex justify-content-center">
          File generato: <strong>{{ filenameVt4 }}</strong>
        </p>
        <div class="mb-4 flex justify-content-center">
          <br />
          <div>
            <label for="id_pratica">Inserisci l'Id della richiesta</label><br />
            <InputMask id="id_pratica" v-model="id_pratica" mask="9999999" />
          </div>
        </div>
        <div class="flex justify-content-center">
          <Button icon="pi pi-link" label="Salva l'ID della richiesta" @click="saveIdPratica" :disabled="id_pratica == ''"/>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import { ref, onMounted, onUnmounted, watch, computed } from "vue";
import moment from "moment";
import * as XLSX from "xlsx";
import Service from "@/services/ask-pratiche/gestione-pratiche";
import Loader from "@/components/Loader.vue";
import { FilterMatchMode } from "primevue/api";
import { useToast } from "primevue/usetoast";
import NotaInvioDocumentazione from "./NotaInvioDocumentazione.vue";
import PreventivoFirmatoBox from "./PreventivoFirmatoBox.vue";
import SottostatiTimeline from "./SottostatiTimeline.vue";
import {
  isPreventivoFirmato,
  ordinaStati,
  preparaPreventivoFirmato,
  statiBasePreventivo,
  timelineFromStati,
  vedeSoloPreventivo,
} from "@/services/ask-pratiche/preventivoFirmato";
export default {
  components: {
    Loader,
    NotaInvioDocumentazione,
    PreventivoFirmatoBox,
    SottostatiTimeline,
  },
  props: {
    data: Array,
    stati: Array,
  },
  setup(props) {
    const toast = useToast();
    const user = ref(null);
    const loader = ref(false);
    const loading = ref(false);
    const service = new Service();
    const Voltura = ref([]);
    const filteredVoltura = ref([]);
    const loadingFilter = ref(false);
    const showFilterButton = ref(false);
    let filtroStatoAttivo = true;
    const newFilesView = ref({});
    const cod_pod = ref("");
    const rappid = ref("");
    const clientid = ref("");
    const timelineData = ref([]);
    const newStati = ref([]);
    const statiSoloPreventivo = computed(() => statiBasePreventivo(newStati.value));
    const dialoginfo = ref(false);
    const showSuccessAlert = ref(false);
    const showSuccessAlert2 = ref(false);
    const isActive = ref(false);
    const selectedpratica = ref({
      code: "",
      cod_pratica: "",
      privato: 1,
      value: {
        file: null,
      },
      coloreStatoPratica: "default",
    });
    const preventivoDialog = ref(false);
    const importoPreventivo = ref(null);
    const preventivoData = ref({
      cod_cliente: null,
      cod_pratica: null, 
      importo: null,
      stato: 0,
      type_pratica: 'Voltura',
      creation_time: null
    });
    const types_stato_pratica = ref([]);
    const activeFilter = ref('');
    const searchCode = ref("");
    const selectedRows = ref([]);
    const massiveSelectedStatus = ref(null);
    const statiDisponibili = ref([]);
    const timelineKey = ref(0);
    const currentRecordIndex = ref(null);
    const dialogVisible = ref(false);
    const nuovaPratica = ref({
      statoPratica: "",
      dataInserimento: "",
      infoContatore: "",
      telefono: "",
      udd: "",
      codicePratica: "",
    });
    const currentDate = new Date();
    const defaultDate = ref(
      currentDate.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      })
    );
    const searchTerm = ref("");
    const filesDialogVisible = ref(false);
    const selectedFiles = ref([]);
    const selectedMatriceId = ref(null);
    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      code: { value: null, matchMode: FilterMatchMode.CONTAINS },
      stato_corrispondente: { value: null, matchMode: FilterMatchMode.EQUALS },
    });
    const types_pp = ref([
      {name:'pod', selected: false, loaded: false, data: [], type: 'ee'},
      {name:'pdr', selected: false, loaded: false, data: [], type: 'gas'}
    ])
    const selectAllRows = () => {
      selectedRows.value = [];
      if (!has_selectedRows.value) {
        filteredVoltura.value.forEach((el) => {
          el.selected = false;
        });
      } else {
        filteredVoltura.value.forEach((el) => {
          if (!el.selected && el.canSelect) {
            el.selected = true;
            selectedRows.value.push(el);
          }
        });
      }
    };
    const currentData = ref()
    const currentItem = ref([])
    const currentType = ref()
    const searchedStatus = ref({
      old: [],
      new: []
    })

    const getListVoltura = async (item = null, status = [null], forceReload = false) => {
      currentItem.value = item
      if (!item.loaded || forceReload) {
        let index = types_pp.value.findIndex(type => type.name == item.name)
        types_pp.value.forEach((el, i)=>{
          el.selected = i == index ? true : false
        })
        loadingFilter.value = true;
        await service.getListVolturaType(item.type, status)
        .then(res => {
          if (status[0] == null) {
            if (forceReload) searchedStatus.value = {old: [], new: []}
            item.data = res
            currentData.value = res
            fetchUploadedFiles(res);              
          }else{
            item.data.push(...res)
            currentData.value.push(...res)
          }        })
        .finally(()=>{
          applyFilter(item.data)
          filterData()
          item.loaded = true
          loadingFilter.value = false;
        })
      }else{
        currentData.value = item.data
        applyFilter(item.data)
      }
      let index = types_pp.value.findIndex(type => type.name == item.name)
        types_pp.value.forEach((el, i)=>{
          el.selected = i == index ? true : false
        })
      currentType.value = item.type
    };
    
    watch(searchTerm, () => {
      filterData();
    });
    const filterData = () => {
      if (searchTerm.value) {
        filteredVoltura.value = Voltura.value.filter((item) =>
          Object.values(item)
            .join(" ")
            .toLowerCase()
            .includes(searchTerm.value.toLowerCase())
        );
      } else {
        filteredVoltura.value = [...Voltura.value];
      }
    };

    let fetchFilesInterval = null;
    const activeFilterType = ref("");
    onMounted(() => {
      types_stato_pratica.value = ordinaStati(props.stati);
      newStati.value = [...types_stato_pratica.value]
      
      // fetchUploadedFiles(props.data);
      fetchTimelineData(props.stati);
      
      // fetchCurrentStatus(props.data);
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        user.value = JSON.parse(atob(storedUser)).user[0];
      }
      // setActiveFilter("filtroPod");
      // fetchFilesInterval = setInterval(fetchUploadedFiles, 5 * 60 * 1000);
    });
    const setSearchedStatus = async () => {
      let old_status = searchedStatus.value.old.map((state => state.id))
      let new_status = searchedStatus.value.new.map((state => state.id))

      const old_set = new Set(old_status)
      const new_set = new Set(new_status)
      const elementiDaCercare = new_status.filter(valore => !old_set.has(valore));
      const elementiDaRimuovere = old_status.filter(valore => !new_set.has(valore));

      filteredVoltura.value = [...filteredVoltura.value.filter(data => !(elementiDaRimuovere.includes(data.cod_type_stato_pratica)))]

      if (!currentData.value) currentData.value = []
      currentData.value = [...currentData.value.filter(data => !(elementiDaRimuovere.includes(data.cod_type_stato_pratica)))]
      
      currentItem.value.data = [...currentItem.value.data.filter(data => !(elementiDaRimuovere.includes(data.cod_type_stato_pratica)))]

      currentItem.value.loaded = false
      await getListVoltura(currentItem.value, elementiDaCercare)

      searchedStatus.value.old = [...searchedStatus.value.new]
    }
    const isVisibleBtnSearchedStatus = computed(()=>{
      return JSON.stringify(searchedStatus.value.old) != JSON.stringify(searchedStatus.value.new) && searchedStatus.value.new.length != 0
    })
    onUnmounted(() => {
      if (fetchFilesInterval) {
        clearInterval(fetchFilesInterval);
      }
    });
    const isVisibleBtnDownloadVolture = computed(() => {
      return selectedRows.value.length;
    });
    const fetchUploadedFiles = async (data) => {
      try {
        // const filesResponse = await service.getListVoltura();        
        data.forEach((item) => {
          // let stato = 'non lavorato';
          let stato = null;
          let canSelect = true;
          if (item.cod_type_stato_pratica) {
            stato = types_stato_pratica.value.find((type) => type.id == item.cod_type_stato_pratica).stato;
            canSelect = false;
          }
          item.stato_corrispondente = stato;
          item.canSelect = canSelect;
        });
        const filesResponse = data;
        const existingFiles = Voltura.value;
        filesResponse.forEach((file) => {
          const existingFileIndex = existingFiles.findIndex(
            (existing) => existing.id === file.id
          );
          if (existingFileIndex !== -1) {
            existingFiles[existingFileIndex] = {
              ...existingFiles[existingFileIndex],
              ...file,
              created_at: moment(file.data).format("YYYY-MM-DD HH:mm:ss"),
              isTimelineVisible: false,
              uniqueId: existingFiles[existingFileIndex].uniqueId,
            };
          } else {
            existingFiles.push({
              ...file,
              created_at: moment(file.data).format("YYYY-MM-DD HH:mm:ss"),
              isTimelineVisible: false,
              uniqueId: existingFiles.length + 1,
            });
          }
        });
        Voltura.value = existingFiles;
        filteredVoltura.value = existingFiles.filter(
          (data) => data.stato_corrispondente !== "completamento"
        );
        loader.value = false;
        newFilesView.value = {};
      } catch (error) {
        console.error("Errore durante il recupero dei file:", error);
        loader.value = false;
      }
    };

    const is_disabled_selected_all = computed(()=>{      
      return !filteredVoltura.value.some(item => item.canSelect)
    })
    const statiMassivi = computed(() =>
      (newStati.value || []).filter((stato) => !isPreventivoFirmato(stato))
    );
    const impostaFilePreventivoFirmato = (file) => {
      if (selectedpratica.value) {
        selectedpratica.value.filePreventivoFirmato = file;
      }
    };

    const applyMassiveStatusChange = async () => {
      if (isPreventivoFirmato(massiveSelectedStatus.value)) {
        toast.add({
          severity: "error",
          summary: "File obbligatorio",
          detail: "Il preventivo firmato va caricato sulla singola pratica.",
          life: 4000,
        });
        return;
      }
      if (!massiveSelectedStatus.value || selectedRows.value.length === 0) {
        return;
      }
      for (let i = 0; i < selectedRows.value.length; i++) {
        const row = selectedRows.value[i];
        const plainRow = JSON.parse(JSON.stringify(row));
        plainRow.selectedStato = massiveSelectedStatus.value;
        service.syncPrivateByNote(plainRow);
        plainRow.tipologia = plainRow.tipologia || "Voltura";
        await inviaNota(plainRow, "Voltura");
      }
      selectedRows.value = [];
      massiveSelectedStatus.value = null;
      await fetchUploadedFiles();
    };
    const saveEdit = async (id, field, value) => {
      try {
        await service.updateUddOrProtocolloSII(id, field, value);
        const recordIndex = Voltura.value.findIndex((item) => item.id === id);
        if (recordIndex !== -1) {
          Voltura.value[recordIndex] = {
            ...Voltura.value[recordIndex],
            [field]: value,
          };
          filteredVoltura.value = [...Voltura.value];
        }
      } catch (error) {
        console.error("Errore durante il salvataggio:", error);
      }
    };
    const downloadPdf = async (matrice_id, name) => {
      loading.value = true;
      await service.downloadPdf(matrice_id, name).finally(() => {
        loading.value = false;
      });
    };
    const downloadZip = async (matrice_id) => {
      loading.value = true;
      await service.downloadZip(matrice_id).finally(() => {
        loading.value = false;
      });
    };
    const filenameVoltura = ref("");
    const applyFilter = async (data) => {
      try {
        filteredVoltura.value = data;
        filteredVoltura.value.forEach((item) => {
          let stato = null;
          let canSelect = true;
          let dataFine = new Date(item.data_fine)
          let dataCorrente = new Date();

          if (item.cod_type_stato_pratica) {
            stato = types_stato_pratica.value.find((type) => type.id == item.cod_type_stato_pratica).stato;
          }

          if (item.cod_type_stato_pratica || (!isNaN(dataFine) && dataFine < dataCorrente && !['admin','pratiche'].includes(user.value.profile.name))) {
            canSelect = false
          }

          item.stato_corrispondente = stato;
          item.canSelect = canSelect;
        });
        Voltura.value = [...filteredVoltura.value];
        
        loadingFilter.value = false;
        showFilterButton.value = true;
      } catch (error) {
        console.error("Errore durante il recupero dei file:", error);
        loadingFilter.value = false;
      }
    };
    const isDownloadedFilePratica = ref(false);
    const ids_richiesta = ref([]);
    const downloadFileVoltura = async () => {
      if (!currentType.value || !selectedRows.value.length || loadingFilter.value) return;
      loadingFilter.value = true;
      const ids = selectedRows.value.map(row => row.id);
      const fd = new FormData();
      fd.append('ids', JSON.stringify(ids));
      try {
        filenameVoltura.value = await service.downloadFilePratica(fd, `vt1-${currentType.value}`);
        isDownloadedFilePratica.value = true;
        selectedRows.value.forEach(row => {
          row.selected = false;
          row.canSelect = false;
        });
        selectedRows.value = [];
        has_selectedRows.value = false;
      } catch (error) {
        console.error(error);
        toast.add({severity: 'error', summary: 'Download non riuscito', detail: error.downloadMessage || 'Impossibile generare il file voltura per le pratiche selezionate', life: 5000});
        return;
      } finally {
        loadingFilter.value = false;
      }
      try {
        await Promise.all([getListVoltura(currentItem.value, [null], true), getActivePratiche()]);
      } catch (error) {
        console.error('Errore aggiornamento elenchi dopo download voltura:', error);
        toast.add({severity: 'warn', summary: 'File generato', detail: 'Il file ? stato generato, ma non ? stato possibile aggiornare gli elenchi. Ricarica la lista.', life: 5000});
      }
    };
    const getActivePratiche = async () => {
      ids_richiesta.value = [];
      await service.getPratiche()
      .then((res) => {
        res.items.forEach((pratica) => {
          if (pratica.id_richiesta) {
            ids_richiesta.value.push(pratica.id_richiesta);
          }
        });
      });
    };
    const rimuoviFiltroStato = () => {
      filtroStatoAttivo = !filtroStatoAttivo;
      let filteredFiles = Voltura.value;
      if (filtroStatoAttivo) {
        filteredFiles = filteredFiles.filter(
          (file) => file.stato_corrispondente !== "completamento"
        );
      }
      if (activeFilterType.value === "filtroPod") {
        filteredFiles = filteredFiles.filter((file) =>
          file.code.startsWith("IT")
        );
      } else if (activeFilterType.value === "filtroPdr") {
        filteredFiles = filteredFiles.filter(
          (file) => !file.code.startsWith("IT")
        );
      }
      const code = searchCode.value.toLowerCase();
      if (code) {
        filteredFiles = filteredFiles.filter((item) =>
          item.code.toLowerCase().includes(code)
        );
      }
      filteredVoltura.value = filteredFiles;
      isActive.value = !isActive.value;
    };
    const fetchTimelineData = async (stati) => {
      try {
        // const response = await service.getStatoPratica();
        if (stati && Array.isArray(stati) && stati.length > 0) {
          timelineData.value = timelineFromStati(stati);
        } else {
          console.error(
            "La risposta dell'API non contiene i dati attesi:",
            stati
          );
        }
      } catch (error) {
        console.error(
          "Errore durante il recupero dei dati della timeline:",
          error
        );
      }
    };
    const fetchCurrentStatus = async (data) => {
      try {
        // const filesResponse = await service.getListVoltura();
        const filesResponse = data;
        const formattedFiles = filesResponse.map((file, index) => ({
          ...file,
          created_at: moment(file.data).format("YYYY-MM-DD HH:mm:ss"),
          isTimelineVisible: false,
          uniqueId: index + 1,
        }));
        Voltura.value = formattedFiles;
        formattedFiles.forEach((pratica) => {
          const timelineItemIndex = timelineData.value.findIndex(
            (item) => item.numero === pratica.cod_type_stato_pratica
          );
          if (timelineItemIndex !== -1) {
            timelineData.value[timelineItemIndex].colore = "blue";
          }
        });
      } catch (error) {
        console.error("Errore durante il recupero dei file:", error);
      } finally {
        loader.value = false;
      }
    };
    const statoToIdMap = {
      Acquisizione: 1,
      "in lavorazione": 2,
      "prima pianificazione": 3,
      sopralluogo: 4,
      preventivo: 5,
      "adempimenti ed autorizzazioni": 6,
      "seconda pianificazione": 7,
      "esecuzione intervento": 8,
      completamento: 9,
    };
    const changePraticaStatus = async (pratica) => {
      service.syncPrivateByNote(pratica);

      try {
        const statoId =
          pratica.selectedStato.id ??
          pratica.selectedStato.numero ??
          statoToIdMap[pratica.selectedStato.stato];
        if (statoId !== undefined) {
          await service.updatePraticaStatus(pratica.id, statoId);
          const index = Voltura.value.findIndex((p) => p.id === pratica.id);
          if (index !== -1) {
            Voltura.value[index].stato_pratica = pratica.selectedStato.stato;
          }
        } else {
          console.error("Stato non mappato:", pratica.selectedStato.stato);
        }
      } catch (error) {
        console.error(
          "Errore durante la gestione del cambio di stato della pratica:",
          error
        );
      }
    };
    const applyHistoryToPratica = (pratica, states, fallbackStatus) => {
      pratica.states = states;

      const currentState = Number(
        states[0]?.cod_type_stato_pratica ?? fallbackStatus
      );

      if (!Number.isNaN(currentState)) {
        pratica.stato_corrispondente =
          states[0]?.stato_corrispondente ?? pratica.stato_corrispondente;
        pratica.cod_type_stato_pratica = currentState;
        pratica.coloreStatoPratica =
          currentState >= 1 && currentState <= 9 ? "blue" : "default";

        timelineData.value = timelineData.value.map((item) => ({
          ...item,
          colore:
            item.numero === currentState
              ? pratica.coloreStatoPratica
              : "default",
        }));
      }
    };

    const openInfoDialog = async (cod_type_stato_pratica, data, index) => {
      try {
        dialoginfo.value = true;
        selectedpratica.value = {
          ...data,
          privato: 1,
          id: data.id,
          clientid: data.clientid || data.client_id || data.id_cliente,
          client_id: data.clientid || data.client_id || data.id_cliente,
          nomerappresentante: data.nomerappresentante || data.NomeCliente || '',
          cognomerappresentante: data.cognomerappresentante || data.CognomeCliente || '',
          numero_telefono: data.numero_telefono || data.telefono || '',
          codiceFiscale: data.codiceFiscale || data.codice_fiscale || '',
          ragsoc: data.ragsoc || data.ragionesociale || '',
          code: data.code || data.codicepod || " - ",
          podid: data.podid,
          rappid: data.rappid,
          codecliente: data.codecliente,
          intestatario: data.intestatario,
          name: data.name,
          ragionesociale: data.ragionesociale,
          codicepod: data.codicepod
        };
        currentRecordIndex.value = index;

        try {
          const response = await service.getPreventivoPratica(data.id, 'Voltura');
          preventivoEsistente.value = response.data;
        } catch (error) {
          preventivoEsistente.value = null;
          console.log('Nessun preventivo esistente');
        }

        const states = await service.getPraticaHistory(data.id, "Voltura");
        applyHistoryToPratica(
          selectedpratica.value,
          states,
          cod_type_stato_pratica
        );
      } catch (error) {
        console.error(
          "Errore durante il recupero dello stato della pratica:",
          error
        );
      }
    };
    const inviaNota = async (rowData) => {
      try {
        service.syncPrivateByNote(rowData);
        const preventivoOk = await preparaPreventivoFirmato({
          service,
          row: rowData,
          typeFile: "Voltura",
          toast,
          lista: Voltura.value,
        });
        if (!preventivoOk) {
          return;
        }
        const privato = rowData.privato ? 1 : 0;
        await service.aggiornaNotePraticaVolturaESubentro(
          rowData.id,
          rowData.nota,
          rowData.selectedStato,
          privato,
          rowData.code,
          rowData.denominazione,
          "Voltura"
        );
        const states = await service.getPraticaHistory(rowData.id, "Voltura");
        applyHistoryToPratica(
          rowData,
          states,
          rowData.selectedStato?.id ?? rowData.selectedStato?.numero
        );
        rowData.nota = "";
        rowData.selectedStato = null;
        rowData.privato = rowData.privato ? 1 : 0;
        // applyFilter(activeFilterType.value);
      
        return true;
      } catch (error) {
        console.error("Errore durante l'aggiornamento della nota:", error);
        return false;
      }
    }


    const ricaricaDialogStato = async () => {
      if (!selectedpratica.value?.id) return;
      await openInfoDialog(
        selectedpratica.value.cod_type_stato_pratica,
        selectedpratica.value,
        currentRecordIndex.value
      );
    };

    const faseInvioStato = ref("");
    const inviaStatoAnimato = async (...argomenti) => {
      if (faseInvioStato.value === "invio") {
        return;
      }
      faseInvioStato.value = "invio";
      let ok = false;
      try {
        ok = Boolean(await inviaNota(...argomenti));
      } catch (error) {
        ok = false;
      }
      if (ok) {
        try {
          await ricaricaDialogStato();
        } catch (error) {
          console.error("Errore durante il ricaricamento della pratica:", error);
        }
      }
      faseInvioStato.value = ok ? "inviato" : "";
      if (ok) {
        setTimeout(() => {
          faseInvioStato.value = "";
        }, 1400);
      }
    };
    const handleButtonClick2 = (rappidValue) => {
      window.open(`/ask/rappresentanti/${rappidValue}/dettagli`);
    };
    const handleButtonClick3 = (clientidValue) => {
      window.open(`/ask/clienti/${clientidValue}/dettagli`);
    };
    const startEditing = (rowData) => {
      rowData.isEditing = true;
    };
    const stopEditing = async (rowData) => {
      try {
        rowData.isEditing = false;
      } catch (error) {
        console.error(
          "Errore durante l'aggiornamento di UDD e Codice Pratica:",
          error
        );
      }
    };
    const handleFileChange = async (event) => {
      const fileInput = event.target;
      const fileLabel = document.getElementById("fileLabel2");
      if (fileInput.files.length > 0) {
        const file = fileInput.files[0];
        const fileName = file.name;
        try {
          fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> ${fileName}`;
          await uploadPreventiviPratiche(file);
          showSuccessAlert.value = true;
          setTimeout(() => {
            showSuccessAlert.value = false;
            fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> Carica Preventivo`;
          }, 3000);
        } catch (error) {
          console.error("Errore durante il caricamento del file:", error);
        }
      } else {
        fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> Carica Preventivo`;
      }
    };
    const handleUploadPratiche = async (event) => {
      const fileInput = event.target;
      const fileLabel = document.getElementById("fileLabel1");
      if (fileInput.files.length > 0) {
        const file = fileInput.files[0];
        const fileName = file.name;
        try {
          fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> ${fileName}`;
          await uploadAllegatiPratiche(file);
          showSuccessAlert2.value = true;
          setTimeout(() => {
            showSuccessAlert2.value = false;
            fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> Carica Allegato`;
          }, 3000);
        } catch (error) {
          console.error("Errore durante il caricamento del file:", error);
        }
      } else {
        fileLabel.innerHTML = `<i class="fas fa-cloud-upload-alt"></i> Carica Allegato`;
      }
    };
    const uploadAllegatiPratiche = async (file) => {
      try {
        const selectedPratica = selectedpratica.value;
        if (
          !selectedPratica ||
          !selectedPratica.code ||
          !selectedPratica.id ||
          !file
        ) {
          throw new Error("File non trovato nella pratica selezionata.");
        }
        const requestData = {
          id: selectedPratica.id,
          code: selectedPratica.code,
          file: file,
        };
        const response = await service.uploadAllegatiPraticheVoltura(
          requestData
        );
        if (
          response &&
          response.message === "File caricati con successo sull'FTP"
        ) {
          console.log("Caricamento effettuato con successo:", response);
        } else {
          console.error("Errore durante il caricamento del file:", response);
          throw new Error("Errore durante il caricamento del file.");
        }
        return response;
      } catch (error) {
        console.error("Errore durante il caricamento del file:", error);
        throw error;
      }
    };
    const downloadAllegatoPratica = async (id, code) => {
      try {
        await service.downloadAllegatoPraticaVoltura(id, code);
      } catch (error) {
        document.getElementById("error-alert").style.display = "block";
        console.error("Errore durante il download del Allegato:", error);
        setTimeout(() => {
          document.getElementById("error-alert").style.display = "none";
        }, 3000);
        throw error;
      }
    };
    const chooseFile = () => {
      document.getElementById("fileInput").click();
    };
    const uploadPreventiviPratiche = async (file) => {
      try {
        const selectedPratica = selectedpratica.value;
        if (
          !selectedPratica ||
          !selectedPratica.code ||
          !selectedPratica.id ||
          !file
        ) {
          throw new Error("File non trovato nella pratica selezionata.");
        }
        const requestData = {
          id: selectedPratica.id,
          code: selectedPratica.code,
          file: file,
        };
        const response = await service.uploadPreventiviPraticheVolturaESubentro(
          requestData
        );
        if (
          response &&
          response.message === "File caricati con successo sull'FTP"
        ) {
          console.log("Caricamento effettuato con successo:", response);
        } else {
          console.error("Errore durante il caricamento del file:", response);
          throw new Error("Errore durante il caricamento del file.");
        }
        return response;
      } catch (error) {
        console.error("Errore durante il caricamento del file:", error);
        throw error;
      }
    };
    const downloadPreventivoPratica = async (id, code) => {
      try {
        await service.downloadPreventivoPraticaVolturaESubentro(id, code);
      } catch (error) {
        document.getElementById("error-alert").style.display = "block";
        console.error("Errore durante il download del preventivo:", error);
        setTimeout(() => {
          document.getElementById("error-alert").style.display = "none";
        }, 3000);
        throw error;
      }
    };
    const openFilesDialog = async (id, matrice_id) => {
      // selectedFiles.value = newFilesView.value[id] || [];
      if (matrice_id in newFilesView.value) {
        selectedFiles.value = newFilesView.value[matrice_id];
      } else {
        await getFileCaricamento(matrice_id).then(() => {
          selectedFiles.value = newFilesView.value[matrice_id];
        });
      }
      selectedMatriceId.value = matrice_id;
      filesDialogVisible.value = true;
    };
    const getFileCaricamento = async (matrice_id) => {
      loadingFilter.value = true;
      await service
        .getFileCaricamento(matrice_id)
        .then((res) => {
          newFilesView.value[matrice_id] = res.items;
        })
        .finally(() => {
          loadingFilter.value = false;
        });
    };
    const showFileUploadButton = () => {
      return true;
    };
    const aggiungiPratica = () => {
      dialogVisible.value = true;
    };
    const uddEditor = {
      template: '<InputText v-model="rowData.udd" />',
    };
    const codicePraticaEditor = {
      template: '<InputText v-model="rowData.codicePratica" />',
    };
    const aggiungiPraticaConferma = async () => {
      try {
        if (
          !nuovaPratica.value.code ||
          !nuovaPratica.value.dataDaNonEseguirePrimaDel ||
          !nuovaPratica.value.telefono ||
          !nuovaPratica.value.infoContatore
        ) {
          return;
        }
        const nuovaPraticaObj = {
          code: nuovaPratica.value.code,
          udd: nuovaPratica.value.udd,
          codicePratica: nuovaPratica.value.codicePratica,
          telefono: nuovaPratica.value.telefono,
          dataDaNonEseguirePrimaDel:
            nuovaPratica.value.dataDaNonEseguirePrimaDel,
          infoContatore: nuovaPratica.value.infoContatore,
        };
        await service.aggiungiPraticaConferma(nuovaPraticaObj);
        showSuccessAlert.value = true;
        dialogVisible.value = false;
        setTimeout(() => {
          showSuccessAlert.value = false;
        }, 3000);
      } catch (error) {
        console.error("Errore durante l'aggiunta della pratica:", error);
      }
    };
    const exportToExcel = () => {
      const data = selectedRows.value.map((item) => ({
        // "Data Creazione": item.data_creazione,
        "Ragione Sociale": item.denominazione,
        "Codice Fiscale": item.cf,
        "Partita Iva": item.piva,
        Referente: item.referente,
        Code: item.code,
        Matricola: item.matricola,
        Remi: item.CodiceRemi,
        "Tipologia uso": item.tipoFornitura,
        Telefono: item.cell,
        Toponimo: item.toponimo,
        Indirizzo: item.indirizzo,
        Civico: item.civico,
        Cap: item.cap,
        Comune: item.comune,
        Provincia: item.code_provincia,
        Istat: item.istat,
        Email: item.email,
        "Ultimo Stato": item.stato_corrispondente,
        "Ultima Nota": item.states && item.states.length > 0
          ? item.states
              .filter((state) => state.type_file === "Voltura")
              .sort((a, b) => new Date(b.data_nota) - new Date(a.data_nota))
              .slice(0, 1)[0]?.nota || ""
          : "",
      }));
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Voltura");
      XLSX.writeFile(workbook, "voltura.xlsx");
    };
    const setActiveFilter = (filter) => {
      activeFilter.value = filter;
      applyFilter(filter);
    };
    const inSelectedRows = (data) => {
      if (data.selected) {
        selectedRows.value.push(data);
      } else {
        let index = selectedRows.value.findIndex((row) => row.id == data.id);
        if (index != -1) {
          selectedRows.value.splice(index, 1);
        }
      }
      if ( selectedRows.value.length != 0) {
        if (selectedRows.value.length < filteredVoltura.value.length) {
          has_selectedRows.value = false
        } else if(selectedRows.value.length == filteredVoltura.value.length){
          has_selectedRows.value = true
        }
      } else if ( selectedRows.value.length == 0) {
        has_selectedRows.value = false
      }
    };
    const has_selectedRows = ref(false);
    const id_pratica = ref()
    const saveIdPratica = () => {
      loadingFilter.value = true;
      if (ids_richiesta.value.includes(id_pratica.value)) {
        loadingFilter.value = false;
        toast.add({
          severity: "warn",
          summary: "Associazione non riuscita",
          detail: `ID di Richiesta già utilizzato`,
          life: 10000,
        });
        id_pratica.value = "";
        return;
      }
      let severity = "success";
      let summary = "Associazione eseguita";
      let detail = `${filenameVoltura.value} è stato associato all'id ${id_pratica.value}`;
      service.saveIdPratica(filenameVoltura.value, id_pratica.value)
      .then((res) => {
        loadingFilter.value = false;
        if (!res) {
          severity = "warn";
          summary = "Associazione non riuscita";
          detail = `${filenameVoltura.value} non è stato associato all'id ${id_pratica.value}`;
        }
        toast.add({
          severity: severity,
          summary: summary,
          detail: detail,
          life: 10000,
        });
      })
      .finally(() => {
        isDownloadedFilePratica.value = false;
      });
    };

    const openPreventivo = () => {
      preventivoDialog.value = true;
    };

    const generaPreventivo = async () => {
      try {
        if (!importoPreventivo.value) {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Importo preventivo non specificato',
            life: 3000
          });
          return;
        }

        preventivoData.value = {
          cod_cliente: selectedpratica.value.clientid,
          cod_pratica: selectedpratica.value.id,
          importo: Number(importoPreventivo.value),
          stato: 0,
          type_pratica: 'Voltura',
          creation_time: new Date().toISOString()
        };

        await service.salvaPreventivoPartica(preventivoData.value);

        preventivoDialog.value = false;
        importoPreventivo.value = null;

        toast.add({
          severity: 'success',
          summary: 'Successo',
          detail: 'Preventivo salvato correttamente',
          life: 3000
        });

      } catch (error) {
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante il salvataggio del preventivo',
          life: 3000
        });
        console.error("Errore durante la generazione del preventivo:", error.response?.data || error);
      }
    };

    const preventivoEsistente = ref(null);
    const rowClass = (data) => {
      return [{ "bg-danger": data.cod_type_stato_pratica == 10 }];
    };

    const isPrivateAutomaticallyManaged = computed(() => {
      return service.getPrivateByNoteRule(
        selectedpratica.value?.selectedStato,
        selectedpratica.value?.nota
      ).isManaged;
    });

    watch(
      [
        () => selectedpratica.value?.selectedStato?.stato,
        () => selectedpratica.value?.nota,
      ],
      () => service.syncPrivateByNote(selectedpratica.value),
      { immediate: true }
    );

    return {
      loader,
      loadingFilter,
      newFilesView,
      Voltura,
      cod_pod,
      rappid,
      clientid,
      handleFileChange,
      chooseFile,
      handleButtonClick3,
      handleButtonClick2,
      timelineData,
      startEditing,
      stopEditing,
      fetchCurrentStatus,
      selectedpratica,
      openInfoDialog,
      dialoginfo,
      changePraticaStatus,
      statiDisponibili,
      timelineKey,
      currentRecordIndex,
      inviaNota,
      faseInvioStato,
      inviaStatoAnimato,
      statiMassivi,
      impostaFilePreventivoFirmato,
      showFileUploadButton,
      uploadPreventiviPratiche,
      showSuccessAlert,
      showSuccessAlert2,
      dialogVisible,
      nuovaPratica,
      aggiungiPratica,
      aggiungiPraticaConferma,
      defaultDate,
      uddEditor,
      codicePraticaEditor,
      downloadPreventivoPratica,
      handleUploadPratiche,
      downloadAllegatoPratica,
      filteredVoltura,
      applyFilter,
      showFilterButton,
      rimuoviFiltroStato,
      filtroStatoAttivo,
      isActive,
      filesDialogVisible,
      selectedFiles,
      openFilesDialog,
      downloadPdf,
      downloadZip,
      selectedMatriceId,
      exportToExcel,
      searchCode,
      activeFilterType,
      saveEdit,
      searchTerm,
      selectedRows,
      massiveSelectedStatus,
      applyMassiveStatusChange,
      user,
      filters,
      types_stato_pratica,
      activeFilter,
      setActiveFilter,
      types_pp,
      getListVoltura,
      currentData,
      currentType,
      inSelectedRows,
      has_selectedRows,
      isVisibleBtnDownloadVolture,
      downloadFileVoltura,
      filenameVoltura,
      isDownloadedFilePratica,
      ids_richiesta,
      selectAllRows,
      id_pratica,
      saveIdPratica,
      toast,
      moment,
      newStati,
      statiSoloPreventivo,
      vedeSoloPreventivo,
      preventivoDialog,
      importoPreventivo,
      preventivoData,
      generaPreventivo,
      openPreventivo,
      preventivoEsistente,
      is_disabled_selected_all,
      searchedStatus,
      setSearchedStatus,
      isVisibleBtnSearchedStatus,
      rowClass,
      isPrivateAutomaticallyManaged,
    };
  },
};
</script>
<style scoped>
.active-button {
  background-color: #007bff;
  color: white;
}
#error-alert {
  display: none;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffcccc;
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 16px;
  color: #ff0000;
  z-index: 1000;
}
.p-grid .p-col-12 {
  margin-bottom: 1rem;
}
.styled-button-Nota {
  background-color: #3498db;
  border: none;
  color: white;
  padding: 14px 24px;
  text-decoration: none;
  font-size: 13px;
  cursor: pointer;
  border-radius: 8px;
  margin-right: 10px;
  margin-bottom: 10px;
  align-self: stretch;
}
.styled-button-Nota:hover {
  background-color: #2980b9;
}
form {
  display: flex;
  flex-direction: column;
}
.form-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.button-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
}
.custom-file-upload {
  display: inline-block;
  padding: 12px 22px;
  font-size: 13px;
  cursor: pointer;
  background-color: #3498db;
  color: #fff;
  border-radius: 8px;
  border: none;
  transition: background-color 0.3s ease;
  margin-right: 10px;
  margin-bottom: 10px;
  text-align: center;
  width: 120px;
}
.custom-file-download {
  display: inline-block;
  padding: 14px 24px;
  font-size: 13px;
  cursor: pointer;
  background-color: #3498db;
  color: #fff;
  border-radius: 8px;
  border: none;
  transition: background-color 0.3s ease;
  margin-right: 10px;
  margin-bottom: 10px;
  text-align: center;
  width: 120px;
}
.custom-file-upload:hover {
  background-color: #2980b9;
}
input[type="file"] {
  display: none;
}
.custom-alert {
  background-color: #4caf50;
  color: white;
  padding: 15px;
  border-radius: 5px;
  position: fixed;
  z-index: 9999;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  animation: fadeInOut 2s forwards;
}
@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.custom-alert:hover,
.custom-alert:focus {
  opacity: 1;
}
.filter-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
  margin-left: 10px;
  align-items: center;
}
.filter-buttons,
.filter-actions {
  display: flex;
  gap: 10px;
}
.active-button {
  background-color: white !important;
  color: blue !important;
}
.custom-alert:hover,
.custom-alert:focus {
  animation: fadeOut 2s ease-in-out forwards;
}
.button-like:hover {
  text-decoration: none;
  color: navy;
}
.table-container {
  margin-top: 20px;
}
.popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  width: auto;
  max-width: 100%;
  max-height: 90vh;
  overflow: auto;
}
.popup-close {
  position: absolute;
  top: 3px;
  right: 5px;
  width: 20px;
  height: 20px;
  border: none;
  background: transparent;
  color: black;
  font-size: 18px;
  font-weight: bold;
  line-height: 1;
  cursor: pointer;
  outline: none;
}
.nota-container {
  display: flex;
  align-items: center;
}
.nota-container input {
  flex: 1;
  margin-right: 5px;
}
.popup-close:hover {
  color: darkgray;
}
.custom-dialog .dialog-content {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}
.custom-dialog .timeline-container {
  flex: 0 0 280px;
  overflow: visible;
  margin: 0;
  padding: 4px 16px 4px 4px;
  border-right: 1px solid #e6ebf1;
}
.data-tables-container {
  flex: 1;
  overflow-x: auto;
}
.file-link {
  color: #3498db;
}
.file-link:hover {
  cursor: pointer;
}
.styled-button-Nota-Preventivo {
  background-color: #269a4d;
  border: none;
  color: white;
  padding: 12px 18px;
  text-decoration: none;
  font-size: 13px;
  cursor: pointer;
  border-radius: 8px;
  
}
.cliente-info {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  margin-top: 10px;
}

.cliente-info p {
  margin: 8px 0;
  line-height: 1.4;
}

.cliente-info b {
  color: #495057;
  min-width: 140px;
  display: inline-block;
}

.preventivo-esistente {
  background-color: #269a4d;
  padding: 15px;
  border-radius: 8px;
  margin-top: 10px;
  text-align: center;
  font-size: 16px;
}

.preventivo-esistente p {
  margin: 0;
  color: #f0f0f0;
}


.custom-dialog :deep(.p-dialog-content) {
  padding: 0.75rem 1rem;
}

.stato-pannello {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.stato-scheda {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  padding: 8px 12px;
  background: #f4f7fb;
  border: 1px solid #e3eaf2;
  border-radius: 8px;
}

.stato-scheda__voce {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.stato-scheda__voce span {
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.stato-scheda__voce strong {
  color: #0f172a;
  font-size: 14px;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.stato-blocco {
  padding: 10px 12px;
  border: 1px solid #e6ebf1;
  border-radius: 8px;
  background: #fff;
}

.stato-blocco h3 {
  margin: 0 0 8px;
  color: #0f3d6e;
  font-size: 14px;
}

.stato-campo {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 8px;
}

.stato-campo > span,
.stato-privato {
  color: #475569;
  font-size: 13px;
  font-weight: 600;
}

.stato-campo :deep(.p-dropdown) {
  width: 100%;
}

.stato-privato {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.stato-nota {
  width: 100%;
  min-height: 44px;
  height: 44px;
  resize: vertical;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 6px 10px;
  font: inherit;
  color: #0f172a;
  box-sizing: border-box;
}

.stato-modulo .styled-button-Nota {
  align-self: flex-start;
  margin: 0;
  min-width: 96px;
  padding: 8px 16px;
}

.stato-file {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.stato-file__riga {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  border-bottom: 1px solid #eef2f6;
}

.stato-file__riga:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.stato-file__nome {
  color: #475569;
  font-size: 13px;
  font-weight: 600;
}

.stato-file .button-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0;
}

.stato-file .custom-file-upload,
.stato-file .custom-file-download {
  width: auto;
  min-width: 148px;
  min-height: 32px;
  margin: 0 8px 0 0;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
}

.stato-importo .styled-button-Nota-Preventivo {
  padding: 8px 14px;
  margin: 0;
}

.stato-storico :deep(.p-datatable .p-datatable-thead > tr > th),
.stato-storico :deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 0.35rem 0.6rem;
}

.stato-storico :deep(.p-paginator) {
  padding: 0.25rem 0 0;
}

.stato-importo .preventivo-esistente {
  margin-top: 0;
  padding: 8px 12px;
  font-size: 14px;
}

.stato-importo .preventivo-esistente p {
  margin: 0;
}

@media (max-width: 900px) {
  .custom-dialog.stato-dialog .dialog-content {
    flex-direction: column;
  }

  .custom-dialog.stato-dialog .timeline-container {
    flex: none;
    width: 100%;
    overflow: visible;
    border-right: none;
    border-bottom: 1px solid #e6ebf1;
  }

  .stato-scheda,
  .stato-file__riga {
    grid-template-columns: 1fr;
  }
}

.timeline-container :deep(.p-timeline-event-opposite) {
  display: none;
  flex: none;
  padding: 0;
}

.timeline-container :deep(.p-timeline-event-content) {
  padding: 0 0 12px 10px;
  line-height: 1.35;
}

.timeline-container :deep(.p-timeline-event-separator) {
  flex: none;
}

.stato-punto {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #cbd5e1;
  box-shadow: 0 0 0 3px #fff, 0 0 0 5px #cbd5e1;
}

.stato-punto--attivo {
  background: #2196f3;
  box-shadow: 0 0 0 3px #fff, 0 0 0 5px #2196f3;
}

.stato-passo__nome {
  display: block;
  margin-top: 1px;
  color: #475569;
  font-size: 14px;
}

.stato-passo__nome--attivo {
  color: #1565c0;
  font-weight: 700;
}


.styled-button-Nota--invio,
.styled-button-Nota--ok {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.styled-button-Nota:disabled {
  opacity: 1;
  cursor: default;
}

.styled-button-Nota--ok {
  background-color: #269a4d;
}

.invio-stato__spinner {
  width: 14px;
  height: 14px;
  margin-right: 8px;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #fff;
  border-radius: 50%;
  animation: invio-stato-giro 0.7s linear infinite;
}

.invio-stato__check {
  display: inline-block;
  margin-right: 6px;
  font-weight: 700;
  animation: invio-stato-pop 0.35s ease;
}

@keyframes invio-stato-giro {
  to { transform: rotate(360deg); }
}

@keyframes invio-stato-pop {
  0% { transform: scale(0.4); opacity: 0; }
  70% { transform: scale(1.15); }
  100% { transform: scale(1); opacity: 1; }
}

</style>
